import type { QuestionLiveResultsResult } from '@/shared-responder-v2-core';

interface DistributionItemPayload {
  readonly value: string;
  readonly count: number;
}

interface QuestionLiveResultsPayload {
  readonly totalResponses: number;
  readonly distribution: readonly DistributionItemPayload[];
}

/**
 * `null` reaches here whenever `questionLiveResults` legitimately declines to
 * compute a tally — not a gateway error, so nothing here throws for it.
 */
export function toQuestionLiveResultsResult(
  payload: QuestionLiveResultsPayload | null
): QuestionLiveResultsResult | null {
  return payload === null
    ? null
    : {
        totalResponses: payload.totalResponses,
        distribution: payload.distribution.map((item) => ({
          count: item.count,
          value: item.value,
        })),
      };
}
